const status = {
	"Refurbishing": "Aufbereitung",
	"Registration": "Registrierung",
	"Ready": "Bereit",
	"Unknown": "Unbekannt"
}

export default status;
